export enum signupProgression {
  INFORMATION = 3,
  LEADER = 4,
  ACTIONARY = 5,
  CONTRACT = 6,
  FINISH = 7,
  CHOISE = 0,
}
